import React from "react";
import { Field, useFormikContext } from "formik";
import moment from "moment";

import { DialogContent, Grid, TextField } from "@material-ui/core";

import { i18n } from "../../translate/i18n";
import TabPanel from "../TabPanel";

/**
 * Tab "Mensagens" — saudação, conclusão, fora de expediente e férias coletivas.
 * Compartilhada entre WhatsAppModal (nativo) e PluginConnectionModal.
 * Lê dados do Formik via useFormikContext — deve renderizar dentro de <Formik>.
 */
const MessagesTab = ({ tab, classes }) => {
  const { values, touched, errors } = useFormikContext();

  return (
    <TabPanel className={classes.container} value={tab} name="messages">
      <DialogContent dividers>
        <Grid container spacing={1}>
          {/* MENSAGEM DE SAUDAÇÃO */}
          <Grid item xs={12} md={12} xl={12}>
            <Field
              as={TextField}
              label={i18n.t("whatsappModal.form.greetingMessage")}
              type="greetingMessage"
              multiline
              rows={4}
              fullWidth
              name="greetingMessage"
              error={touched.greetingMessage && Boolean(errors.greetingMessage)}
              helperText={touched.greetingMessage && errors.greetingMessage}
              variant="outlined"
              margin="dense"
            />
          </Grid>

          {/* MENSAGEM DE CONCLUSÃO */}
          <Grid item xs={12} md={12} xl={12}>
            <Field
              as={TextField}
              label={i18n.t("whatsappModal.form.complationMessage")}
              multiline
              rows={4}
              fullWidth
              name="complationMessage"
              error={touched.complationMessage && Boolean(errors.complationMessage)}
              helperText={touched.complationMessage && errors.complationMessage}
              variant="outlined"
              margin="dense"
            />
          </Grid>

          {/* MENSAGEM DE FORA DE EXPEDIENTE */}
          <Grid item xs={12} md={12} xl={12}>
            <Field
              as={TextField}
              label={i18n.t("whatsappModal.form.outOfHoursMessage")}
              multiline
              rows={4}
              fullWidth
              name="outOfHoursMessage"
              error={touched.outOfHoursMessage && Boolean(errors.outOfHoursMessage)}
              helperText={touched.outOfHoursMessage && errors.outOfHoursMessage}
              variant="outlined"
              margin="dense"
            />
          </Grid>

          {/* MENSAGEM DE FÉRIAS COLETIVAS */}
          <Grid item xs={12} md={12} xl={12}>
            <Field
              as={TextField}
              label={i18n.t("whatsappModal.form.collectiveVacationMessage")}
              multiline
              rows={4}
              fullWidth
              name="collectiveVacationMessage"
              error={
                touched.collectiveVacationMessage &&
                Boolean(errors.collectiveVacationMessage)
              }
              helperText={
                touched.collectiveVacationMessage && errors.collectiveVacationMessage
              }
              variant="outlined"
              margin="dense"
            />
          </Grid>

          <Grid item xs={6}>
            <Field
              fullWidth
              as={TextField}
              label={i18n.t("whatsappModal.form.collectiveVacationStart")}
              type="date"
              name="collectiveVacationStart"
              required={values.collectiveVacationMessage?.length > 0}
              inputProps={{
                min: moment().add(-10, "days").format("YYYY-MM-DD"),
              }}
              InputLabelProps={{ shrink: true }}
              error={
                touched.collectiveVacationStart &&
                Boolean(errors.collectiveVacationStart)
              }
              helperText={
                touched.collectiveVacationStart && errors.collectiveVacationStart
              }
              variant="outlined"
            />
          </Grid>

          <Grid item xs={6}>
            <Field
              fullWidth
              as={TextField}
              label={i18n.t("whatsappModal.form.collectiveVacationEnd")}
              type="date"
              name="collectiveVacationEnd"
              required={values.collectiveVacationMessage?.length > 0}
              inputProps={{
                min: moment().add(-10, "days").format("YYYY-MM-DD"),
              }}
              InputLabelProps={{ shrink: true }}
              error={
                touched.collectiveVacationEnd &&
                Boolean(errors.collectiveVacationEnd)
              }
              helperText={
                touched.collectiveVacationEnd && errors.collectiveVacationEnd
              }
              variant="outlined"
            />
          </Grid>
        </Grid>
      </DialogContent>
    </TabPanel>
  );
};

export default MessagesTab;
